import { createContext } from "react";

import type { PusherContextValues } from "./types.js";

// context setup
const PusherContext = createContext<PusherContextValues>({});
export const __PusherContext = PusherContext;
